import * as React from "react";
import { cn } from "@/lib/utils";
export interface TextareaProps extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {
  minRows?: number;
  maxRows?: number;
}
const Textarea = React.forwardRef<HTMLTextAreaElement, TextareaProps>(({
  className,
  minRows,
  maxRows,
  style,
  ...props
}, ref) => {
  const textareaStyle: React.CSSProperties = {
    ...style,
    minHeight: minRows ? `${minRows * 1.5}rem` : undefined,
    maxHeight: maxRows ? `${maxRows * 1.5}rem` : undefined,
    overflowY: maxRows ? "auto" : undefined
  };
  return <textarea className={cn("peer block w-full rounded-3xl border border-input bg-background px-4 py-3 text-sm text-foreground transition focus:border-primary focus:outline-none focus:ring-primary disabled:cursor-not-allowed disabled:opacity-50", "placeholder:text-muted-foreground focus:placeholder:text-muted-foreground", className)} ref={ref} style={textareaStyle} {...props} />;
});
Textarea.displayName = "Textarea";
export { Textarea };